import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-modal-contacto-vendedor',
  templateUrl: './modal-contacto-vendedor.component.html',
  styleUrls: ['./modal-contacto-vendedor.component.scss'],
})
export class ModalContactoVendedorComponent implements OnInit {
  @Input() contact: any;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() welcome: any;
  @Input() showWelcome: boolean = true;
  @Input() buttonsWelcome: any;
  @Input() buying;
  @Input() message: string;
  @Input() creatingStore = false;
  @Input() buttonsCreateStore: any[];
  @Input() numberWp
  @Input() data
  @Input() onEditCurrency:any;

  logoTelegram: string = './assets/img/icons/telegramwhite.svg';
  buttonsContact = [
    {
      icon: 'logo-whatsapp',
      name: 'Whatsapp',
    },
    {
      icon: 'call',
      name: 'Llamada',
    },
    {
      icon: 'mail-outline',
      name: 'E-mail',
    },
  ];
  constructor(
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit() {
    
    if(this.onEditCurrency){
      this.showWelcome = false;
      this.creatingStore = true;
    }

    // if(this.buying){
    //   let url;
    //   if(this.numberWp.includes('https')){
    //     url = `${this.numberWp}&text=Pedido hecho desde tu tienda On Line en Amarillas App %0A${this.data}`
    //   }else{
    //     url = `https://api.whatsapp.com/send?phone=${this.numberWp}&text=Pedido hecho desde tu tienda On Line en Amarillas App %0A${this.data}`
    //   }
    //   setTimeout( async () => {
    //     await this.modalCtrl.dismiss();
    //     window.open(
    //       `${url}`,
    //       '_blank'
    //     );
    //   }, 2500);
    // }
  }
  

  closeModal(ev?) {
    this.modalCtrl.dismiss(ev);
  }

  goDirectory(){
    this.modalCtrl.dismiss();
    this.router.navigate(['/login/perfil/directorio']);
  }

  goTo(route: string) {
    if (route.includes('search')) {
      this.router.navigate([route], { queryParams: { promo: 1 } });
    } else {
      this.router.navigate([route]);
    }
    this.modalCtrl.dismiss();
  }

  goChat(social: string) {
    console.log(social);
    if (social == 'logo-whatsapp' && this.contact.number_wp) {
      window.open(
        `https://api.whatsapp.com/send?phone=${this.contact.number_wp}`,
        '_blank'
      );
    } else if (social == 'call' && this.contact.number) {
      window.open(`tel:${this.contact.number}`, '_self');
      return
    } else if (social == 'E-mail' && this.contact.email) {
      window.navigator.clipboard.writeText(this.contact.email);
      this.toastService.show('Copiado al portapapeles')
      return
    } else if (social == 'Telegram' && this.contact.telegram) {
      window.open(this.contact.telegram);
    } else {
      this.toastService.show('El vendedor no dispone de la opcion seleccionada');
    }
  }
}
